import { connect } from 'react-redux'
import React from 'react';
import './promo-system.scss';

const PromoSystem = ({ price, partner, ...props }) => {
	return(
		<div
			className="promosystem--wrapper ua-margin-top-auto"
			{...props}
		>
			<strong>
				{price}
			</strong>
			{partner}
		</div>
	);
};

export default PromoSystem;
